import React from 'react'
import styles from "./Сonverters.module.scss";

const LinearConverter = ({ k, b }) => {    
    return <div className={styles.centerText}>{`V = ${k} * A + ${b}`}</div>
}

export default LinearConverter;